/**
 * Bootstrap Setup
 * Initializes Bootstrap components: popovers, modals
 */

import { createPopper } from '@popperjs/core';
const bootstrap = require('bootstrap');

// Expose globally for components that need it
window.bootstrap = bootstrap;

/**
 * Initialize Bootstrap popovers with HTML content support
 * Uses getOrCreateInstance() to avoid duplicate instances on Turbo navigation
 */
export function initPopovers() {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  return [...popoverTriggerList].map(popoverTriggerEl => {
    // Check if already initialized
    const existing = bootstrap.Popover.getInstance(popoverTriggerEl);
    if (existing) return existing;

    // Create new instance with options
    const opts = { html: true, sanitize: false };
    if (popoverTriggerEl.getAttribute('data-popover-source') === 'sibling') {
      opts.content = () => {
        const sibling = popoverTriggerEl.parentElement?.querySelector('.popover-html');
        return sibling ? sibling.innerHTML : '';
      };
    }
    return new bootstrap.Popover(popoverTriggerEl, opts);
  });
}

/**
 * Initialize legacy modal-link handlers
 * These are links with data-toggle="modal" that fetch content via AJAX
 * 
 * Note: Uses a data attribute marker to prevent duplicate event listeners
 * when called multiple times (e.g., on each Turbo navigation)
 */
export function initModalLinks() {
  const modal = document.getElementById('modal');
  if (!modal) {
    console.debug('JS Modal element not found.');
    return;
  }

  const modalBody = modal.querySelector('.modal-body');

  // Only initialize links that haven't been initialized yet
  document.querySelectorAll('a.modal-link[data-toggle="modal"]:not([data-modal-initialized])').forEach(link => {
    // Mark as initialized to prevent duplicate listeners
    link.setAttribute('data-modal-initialized', 'true');
    
    link.addEventListener('click', async (event) => {
      event.preventDefault();
      const url = link.href;

      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const article = doc.querySelector('article');

        modalBody.innerHTML = article ? article.innerHTML : '<p>Content not found.</p>';

        const modalInstance = new bootstrap.Modal(modal, {
          backdrop: true,
          keyboard: true,
          focus: true
        });
        modalInstance.show();
      } catch (error) {
        console.error('Failed to load modal content:', error);
        modalBody.innerHTML = '<p>Failed to load content.</p>';
      }
    });
  });
}

export { bootstrap, createPopper };

